import Cookies from 'universal-cookie';
import { getStatusList } from "./ApiService1"

const cookies = new Cookies();

export const DIRECT_TYPES = [
    {
        text: 'OKTA',
        value: 'OKTA'
    },
    {
        text: 'Oracle IDCS',
        value: 'IDCS'
    },
    {
        text: 'LDAP',
        value: 'LDAP'
    },
    {
        text: 'Active Directory',
        value: 'AD'
    },
    {
        text: 'AWS',
        value: 'AWS'
    }
];

export const getDueColor = (dueDays) => {
  let dueColor = '#1890ff';
  if (dueDays > 5 && dueDays <= 10) {
    dueColor = '#e2e271'
  } else if (dueDays < 5) {
    dueColor = '#dc3545'
  }
  return dueColor;
}

export const getDueDaysColor = (dueDays) => {
    let dueColor = '#1890ff';
    if (dueDays <= 30) {
        dueColor = '#52c41a'
    } else if (dueDays <= 70) {
        dueColor = 'orange'
    } else if(dueDays > 70) {
        dueColor = '#dc3545'
    }
    return dueColor;
}

export const getCertificationColor = (dueDays) => {
  let dueColor = '#1890ff';
  if (dueDays <= 30) {
    dueColor = '#dc3545'
  } else if (dueDays <= 70) {
    dueColor = 'orange'
  } else if(dueDays > 70) {
      dueColor = '#52c41a'
  }
  return dueColor;
}

export const getOrphanFlags = (profile) => {
    if(!profile){return {}}
    const object = {}
    if(profile.federated === "No" && profile.is_mfa_activated === "FALSE"){
        object.isMFADisabled = true;
    }
    if(profile.isLinkedAccount === "NO"){
        object.isOrphanAccount = true;
    }
    return object
}

export const keyRegexToLabel = (key) => {
    return (key && key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\_/g, " ").replace(/\b[a-z]/g, (x) => x.toUpperCase())) || key
}

export const statusList = (key) => {
  const state = {
      ...getStatusList()
  }

  return (state || {})[key] || []
}

export const dateFormat = () => localStorage.getItem("DATE_FORMAT") || "YYYY/MM/DD";

export const clearCookies = () => {
    cookies.remove('USER_PWD_TOKEN');
    cookies.remove('JWT_ACCESSTOKEN1');
    cookies.remove('JWT_ACCESSTOKEN2');
    cookies.remove('REGISTERED_APPNAME');
    cookies.remove('LOGGEDIN_USERID');
    cookies.remove('LAST_LOGIN');
}

export const getAccessToken = () => cookies.get('JWT_ACCESSTOKEN1')+cookies.get('JWT_ACCESSTOKEN2') || ""

export const getIsSSO = () => {
    const value = localStorage.getItem('isSSO')
    return !(value && value.toString() === "false");
}

export const getSSOEnabled = () => localStorage.getItem('SSOEnabled') || ''

export const setSSOValue = (url = '') => {
    if(getIsSSO()) {
        const isQuery = url.includes("?")
        return `${url}${isQuery ? "&" : `?`}SSOEnabled=${getSSOEnabled()}`
    }
    return url
}